<template>
  <div>
    <div class="container">
      <div class="row mt-5">
        <div class="col-12 text-center ">
          <h4>Resultados de busqueda</h4>
          <h5>{{ id }}</h5>
        </div>
      </div>
    </div>
    <div class="buscar mb-5">
      <div class="container pt-3 border-top">
        <div class="row text-left" :key="k" v-for="(d, k) in results">
          <div class="col-3">
            <span>Nro. de informe</span>
          </div>
          <div class="col-3">
            <span>T.H.</span>
          </div>
          <div class="col-4">
            <span>Títular</span>
          </div>
          <div class="col-2">
            
          </div>
        </div>

        <div class="row border-bottom pb-1 mb-2" :key="k" v-for="(d, k) in results">
          <div class="col-3">
            <h4>{{ d.nro_informe }}</h4>
          </div>
          <div class="col-3">
            <h4>{{ d.numero_th }}</h4>
          </div>
          <div class="col-4">
            <h4>{{ d.titular_actual }}</h4>
          </div>
          <div class="col-2">
            <div>
              <router-link  :to="{ name: 'PlanPageDetalles' , params:{ id: d.resolucion_poa_id}}"
                               class="btn btn-dark"> Ver plan</router-link>
            </div>
          </div>
        </div>
      </div>      
    </div>
    <div class="mt-5"><Footer/></div>
  </div>    
</template>

<script>

  import { filter } from 'lodash'
  import '@trevoreyre/autocomplete-vue/dist/style.css'
  import Footer from '@/components/Footer'
  import api from '@/api/api'

  export default {
    name: 'BuscadorMenuPlanes',
    components: {
      Footer
    },
    data() {
      return {
        results: [],
        mixins: [api],
        id: ``
      }
    },
    mounted() {
      if(this.$route.query.nro_informe) {
        this.id = this.$route.query.nro_informe
        this.search(this.id)
      }
    },    
    methods: {
      search(input) {

        if (input.length < 1) { return [] }
        this.results = filter(this.dataset, item => {
          if(item.nro_informe.toLowerCase().startsWith(input.toLowerCase()) || item.numero_th.toLowerCase().startsWith(input.toLowerCase()) || item.resolucion_poa.toLowerCase().startsWith(input.toLowerCase())) {              
            return item
          }
        })
      }
    }
  }
  
</script>